module.exports = __webpack_public_path__ + "static/media/llamar2.a2e2b95c.png";